import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import HomePageUI from './HomePageUI.js'

class HomePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <HomePageUI
        context={this.props.context}
        messageList={this.state.messageList}
        socialLoginUrl={this.state.socialLoginUrl}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    if (context.session.userId) {
      if (context.permissions.includes('su_view')) {
        window.location.href = '/su'
        return
      }
      switch (context.session.appCode) {
        case 'finapp':
          window.location.href = '/home'
          break
        case 'projectapp':
          window.location.href = '/projects'
          break
        default:
      }
      return
    }

    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_login',
      'c_new_usr_sign_up',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_home', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default HomePageSF
